import { hubbleAPI } from './url'
const easyResource = hubbleAPI + 'public/easy/payment'
const mobilePayResource = hubbleAPI + 'public/mobilepay/payment'
export default ($axios) => ({
  /**
   * Generates payment id and checkoutKey for the user.
   * @param {*} userName
   * @param {*} a paymentPayload
   * @returns {Promise<{paymentId: string, checkoutKey: string, reference: string}>}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  generateEasyPaymentId(userName, paymentPayload) {
    const config = { headers: { 'Content-Type': 'application/json', charset: 'UTF-8' } };
    return $axios.post(`${easyResource}/initialize`, paymentPayload, config)
  },
  /**
   * Generates payment id and checkoutKey for the user.
   * @param {*} userName
   * @param paymentPayload
   * @returns {Promise<{paymentId: string, checkoutKey: string, reference: string}>}
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  generateMobilePaymentId(userName, paymentPayload) {
    const config = { headers: { 'Content-Type': 'application/json', charset: 'UTF-8' } };
    return $axios.post(`${mobilePayResource}/initialize`, paymentPayload, config)
  },
  /**
   * Generates payment id and checkoutKey for the user.
   * @param {*} userName
   * @param paymentPayload
   * @returns {Promise<{paymentId: string, checkoutKey: string, reference: string}>}
   */

  verifyPayment(paymentPayload) {
    const config = { headers: { 'Content-Type': 'application/json', charset: 'UTF-8' } };
    return $axios.post(`${hubbleAPI}secure/public/ct/verify/payment`, paymentPayload, config)
  },
  hasExistingMobilePayAgreement(cartId) {
    return $axios.get(`${hubbleAPI}secure/public/ct/mobilepay/agreement/${cartId}`, {
      headers: { 'Content-Type': 'application/json' }
    })
  },

  /**
   * Generates payment id and checkoutKey for the user.
   * @returns {Promise<{paymentId: string, checkoutKey: string, reference: string}>}
   * @param cartId id of the customers cart
   */

  isAccountPaymentAllowed(cartId) {
    return $axios.get(`${hubbleAPI}secure/public/ct/account/payment/${cartId}`)
  },
  /**
   * Check if there are no existing payment on the cart
   * @returns {Promise<{booleanResult}>}
   * @param cartId id of the customers cart
   */

  isReadyForPayment(cartId) {
    return $axios.get(`${hubbleAPI}/public/ct/cart/ready-for-payment/${cartId}`)
  }
})
